<span id="tags-label" class="active mdb-group-label"> Available Tags </span>

<div id="group-tags" role="group" aria-labelledby="tags-label" class="mt-3">
  <span name="tags" class="form-check form-check-inline" *ngFor="let tag of displayableTags()">
    <input
      class="form-check-input"
      type="checkbox"
      id="tag_{{ tag.id }}"
      [value]="tag.id"
      [(ngModel)]="tag.active"
      (change)="saveTags(tag)"
    />
    <label
      for="tag_{{ tag.id }}"
      class="form-check-label tags-label"
      [ngClass]="{
        'update-success': tag.recentlyUpdated,
        'update-fail': tagSaveFailed
      }"
    >
      {{ tag.name }}
    </label>
  </span>
</div>
